import { jsx as _jsx } from "react/jsx-runtime";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { defineStyles } from '../../theme';
const styles = defineStyles({
    loadingContainer: {
        zIndex: 100,
        color: (theme) => theme.palette.secondary.main,
    },
    contained: {
        position: 'absolute',
    },
});
const LoadingBackdrop = ({ isLoading, contained }) => (_jsx(Backdrop, { sx: [styles.loadingContainer, contained ? styles.contained : {}], open: isLoading, invisible: true, children: _jsx(CircularProgress, { color: "inherit" }) }));
export default LoadingBackdrop;
//# sourceMappingURL=LoadingBackdrop.js.map